import {
  wrapperStyles,
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  typoHeader,
  typoHeaderMobile,
  typoParagraph,
} from 'components/Templates/styles/Red/commonObjectsStyles';


/* eslint-disable */


const thisStyle = {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color' : '{sectionBackgroundColor}'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  sectionTitle: {
    '0': {
      ...typoHeader,
    },
    '76_8' : {
      ...typoHeaderMobile,
    },
  },
  paragraph: {
    '0': {
      ...typoParagraph,
      'margin-bottom' : '7rem'
    },
    '76_8' : {
      'margin-bottom' : '3rem'
    }
  },
  listElementWrapper: {
    '0': {
      'display': 'flex',
      'align-items': 'baseline',
      'width': '100%'
    }
  },
  listElement: {
    '0': {
      ...typoHeader,
      'margin-bottom' : '3.5rem',
      'color': '{textColor}',
      'margin-left': '3rem'
    },
    '76_8' : {
      ...typoHeaderMobile,
      'color': '{textColor}',
    }
  },
};

export default thisStyle;

